import { computed } from 'vue';
import { useQuoteStore } from '@/stores/quoteStore';
import { useQuoteGeneration } from '@/composables/useQuoteGeneration';
import type { ResultsViewProps } from '@/components/widget/results/results-view.types';
import type { QuoteSources } from './types';

export function useQuoteSources(props: Readonly<ResultsViewProps>) {
  const quoteStore = useQuoteStore();
  const quoteGeneration = props.quoteGeneration || useQuoteGeneration();
  const quotesResponse = computed(() => props.quotesResponse || quoteGeneration.quotesResponse.value);

  const sources: QuoteSources = {
    quoteData: quoteStore.quoteData,
    quotesResponse,
    anaQuotes: quoteGeneration.anaQuotes,
    chubbQuotes: quoteGeneration.chubbQuotes,
    chubbError: quoteGeneration.chubbError,
  };

  return { quoteGeneration, sources };
}
